module.exports = __webpack_public_path__ + "media/images/business/design-timeline-4445132694c990ff18269622e1453089.svg";